import barba from '@barba/core';
import { gsap } from 'gsap';

export default class WorkSwitcher {
	constructor(elm) {
		this.elm = elm;
        if(this.elm) {
            this.wrapper = this.elm.querySelector('[data-switcher]');
            this.switcherItems = this.elm.querySelectorAll('[data-switcher-item]');
            this.pill = this.elm.querySelector('[data-pill]');
        }

        document.addEventListener('show-switcher', () => {
			this.show();
		});

		document.addEventListener('hide-switcher', () => {
			this.hide();
		});

        document.addEventListener('update-switcher', event => {
			this.switch(event.detail.namespace, event.detail.duration);
		});

        const activeRect = this.switcherItems[0].getBoundingClientRect();

        gsap.set(this.pill, {
            width: activeRect.width+10,
            left: (activeRect.left - this.wrapper.getBoundingClientRect().left)-8,
            autoAlpha: 0.2
        });

        this.createTimeline();

        this.tl.seek('label-'+barba.history.current.ns);
	}

    createTimeline() {
        this.tl = gsap.timeline({
            paused: true
        });

        this.switcherItems.forEach(item => {
            const itemRect = item.getBoundingClientRect();
            const itemNamespace = item.getAttribute('data-target-namespace');

            this.tl.to(this.pill, {
                width: itemRect.width+10,
                x: (itemRect.left - this.wrapper.getBoundingClientRect().left)-5,
                duration: 1
            });
            this.tl.addLabel('label-'+itemNamespace);
        });
    }

    switch(namespace, duration) {
        this.switcherItems.forEach(item => {
            item.classList.remove('is-active');
            item.removeAttribute('tabindex');
            const itemNamespace = item.getAttribute('data-target-namespace');
            if(itemNamespace===namespace) {
                item.classList.add('is-active');
                item.setAttribute('tabindex', -1);
            }
        });

        if(namespace=='template-work'||namespace=='template-features') {
            if(duration==0) {
                this.tl.seek('label-'+namespace);
            } else {
                this.tl.tweenTo('label-'+namespace, {
                    duration: duration,
                    ease: 'expo.inOut'
                });
            }
        }
    }

    show() {
        gsap.to(this.elm, {
            autoAlpha: 1,
            duration: 0.3,
            ease: 'none',
            onComplete: () => {
                gsap.set(this.elm, {
                    zIndex: 100 // change zindex to re-repaint (becasue sometimes the backdrop-filter: blur is not rendering after the animation)
                });
            }
        });
    }

    hide() {
        gsap.to(this.elm, {
            autoAlpha: 0,
            duration: 0.3,
            ease: 'none'
        });
    }

}